// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gen-org-cert-dialog.common-dialog[data-v-76f9256b] .el-dialog{width:var(--common-dialog-width)}.gen-org-cert-dialog.common-dialog .el-form[data-v-76f9256b]{margin-right:var(--common-dialog-form-margin-right)}", ""]);
// Exports
module.exports = exports;
